<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Payment Link"
              bc1="App"
              bc2="Payment Link"
              bc3="Attempts"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="mt-2 mr-2">
            <div class="row">
              <div class="col-md-12 col-12">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-gradient-danger "
                      @click="$router.back()"
                  >
                    <span class="text-nowrap">Back</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-12">
              <div class="card">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th>IP</th>
                      <th>Time/Date</th>
                      <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-if="!loader">
                      <tr v-for="(item,index) in attempts" :key="index">
                        <td class="text-primary">{{ item.ip }}</td>
                        <td>{{customFormatDateTime(item.created_at)}}</td>
                        <td><button type="button" class="btn-warning btn-sm" @click="getLogs(item)">Logs</button></td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="3" class="text-center align-middle">
                          <div class="d-flex justify-content-center align-items-center" style="height: 100px;">
                            <div class="spinner-border text-primary"></div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>



export default {
  mounted() {
    this.sendCall()
  },
  data() {
    return {
      attempts: [],
      loader:false
    }
  },
  methods: {
    getLogs(row){

      // this.$store.commit('setPaymentLinkLogsData',row)
      let data = {
        row: row,
        key: "paymentLinkLogsData"
      };
      this.$store.dispatch("set", data);
      this.$router.push({name : 'payment-link-attempt-detail',params: {id:this.$route.params.id}})
    },
    sendCall() {
      let data = {
        paymentLinkId: this.$route.params.id,
        getLinkAttemps: 1,
      };
      let tData = this.$store.getters.getByKey(
          data.paymentLinkId+"_p_attempts_details"
      );
      if (tData) {
        this.attempts = tData?.data
        return
      }
      this.loader = true
      this.makeRequest('post', 'v1/get-payment-link', data,{},false).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let responeDataToSave = {
              data: callResponse.response.data.data,
              key: data.paymentLinkId+"_p_attempts_details"
            };
            this.$store.dispatch("setWithoutLocalStorage", responeDataToSave);
            this.attempts = callResponse.response.data.data
          }
        }

      });


    },
  }
}
</script>

